/** localStorage key: Shop BOM system dropdown only; value is JSON map scope → uuid. */
export const SHOP_BOM_SELECTED_SYSTEM_UUID_STORAGE_KEY = 'shopBomSelectedSystemUuid'

type ShopBomSelectedSystemUuidMap = Record<string, string>

function scopeKey(orgId: number, projectId: number): string {
  return `${orgId}:${projectId}`
}

function readMap(): ShopBomSelectedSystemUuidMap {
  if (typeof localStorage === 'undefined') return {}
  try {
    const raw = localStorage.getItem(SHOP_BOM_SELECTED_SYSTEM_UUID_STORAGE_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw) as unknown
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {}
    const out: ShopBomSelectedSystemUuidMap = {}
    for (const [k, v] of Object.entries(parsed as Record<string, unknown>)) {
      if (typeof k === 'string' && typeof v === 'string' && v) {
        out[k] = v
      }
    }
    return out
  } catch {
    return {}
  }
}

function writeMap(map: ShopBomSelectedSystemUuidMap): void {
  if (typeof localStorage === 'undefined') return
  try {
    localStorage.setItem(SHOP_BOM_SELECTED_SYSTEM_UUID_STORAGE_KEY, JSON.stringify(map))
  } catch {
    // Quota or private mode — ignore
  }
}

export function readShopBomSelectedSystemUuid(orgId: number | undefined, projectId: number | undefined): string | null {
  if (orgId == null || projectId == null) return null
  const map = readMap()
  return map[scopeKey(orgId, projectId)] ?? null
}

export function writeShopBomSelectedSystemUuid(
  orgId: number | undefined,
  projectId: number | undefined,
  systemUuid: string
): void {
  if (orgId == null || projectId == null || !systemUuid) return
  const map = readMap()
  map[scopeKey(orgId, projectId)] = systemUuid
  writeMap(map)
}
